export default "__VITE_ASSET__DwfbhADi__"